
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 80418,
	"./src/blueslip.ts": 7717,
	"./src/blueslip_stacktrace.ts": 51761,
	"./src/bundles/common.ts": 16004,
	"./src/csrf.ts": 60737,
	"./src/sentry.ts": 8308,
	"./styles/portico/collaborychat_landing.css": 87894,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"@sentry/conventions/attributes": 59966,
	"core-js/modules/es.array.includes.js": 66326,
	"core-js/modules/es.array.push.js": 97211,
	"core-js/modules/es.iterator.constructor.js": 86074,
	"core-js/modules/es.iterator.map.js": 33520,
	"core-js/modules/es.json.parse.js": 56133,
	"core-js/modules/es.json.stringify.js": 28987,
	"core-js/modules/es.map.get-or-insert-computed.js": 346,
	"core-js/modules/es.map.get-or-insert.js": 88536,
	"error-stack-parser": 69363,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021
};